import { render, staticRenderFns } from "./kx1-imgs-swiper.vue?vue&type=template&id=adf53658&scoped=true"
import script from "./kx1-imgs-swiper.vue?vue&type=script&lang=js"
export * from "./kx1-imgs-swiper.vue?vue&type=script&lang=js"
import style0 from "./kx1-imgs-swiper.vue?vue&type=style&index=0&id=adf53658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf53658",
  null
  
)

export default component.exports